import { GaApp } from '~/modules/app'

export default defineNuxtPlugin({
  name: 'init-app',
  setup() {
    const nuxtApp = useNuxtApp()
    const config = useRuntimeConfig()

    return {
      provide: {
        gaApp: new GaApp(nuxtApp, config.public),
      },
    }
  },
})
